var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-wrap"},[_c('span',{staticClass:"font-8"},[_vm._v(_vm._s(_vm.name)+" status")])])}
var staticRenderFns = []

export { render, staticRenderFns }